export default "__VITE_ASSET__BlCrHQHo__"